import {
  Content,
  ExtrasContent,
  ContentRootTree,
  ContentTree,
} from '../model/extras.domain';
import { defaultValues } from './extras.mappers';
// import { findPath, insertOn } from './tree';

export const addImage =
  (p: { file: File; id: string; parentId: string }) =>
  (prev: ExtrasContent): ExtrasContent => {
    // const path = findPath(prev.contentIds, p.parentId);
    // const nextContentIds = insertOn(path, prev.contentIds, p.id);
    return {
      // contentIds: nextContentIds,
      ...prev,
      contentMap: {
        ...prev.contentMap,
        [p.id]: {
          type: 'ContentImage',
          value: { ...defaultValues['ContentImage'], file: p.file, id: p.id },
        } as Content,
      },
      childrenMap: {
        ...prev.childrenMap,
        [p.parentId]: [...(prev.childrenMap[p.parentId] || []), { id: p.id }],
      },
    };
  };

export const removeImage =
  (p: { parentId: string; imageId: string }) => (prev: ExtrasContent) => {
    const { [p.imageId]: _removed, ...remainingContentMap } = prev.contentMap;

    // remove from tree as well
    const removeFromTree = (
      node: ContentRootTree | ContentTree,
    ): ContentRootTree | ContentTree => {
      if (!node?.items?.length) return node;
      const filtered = node.items
        .filter((c) => c.id !== p.imageId)
        .map(removeFromTree);
      return { ...node, items: filtered } as ContentRootTree | ContentTree;
    };

    return {
      ...prev,
      contentIds: removeFromTree(prev.contentIds),
      childrenMap: {
        ...prev.childrenMap,
        [p.parentId]: prev.childrenMap[p.parentId]?.filter(
          (child) => child.id !== p.imageId,
        ),
      },
      contentMap: remainingContentMap,
    };
  };
